module.exports = __webpack_public_path__ + "img/item-3.ee5d0f5.svg";